module.exports = __webpack_public_path__ + "img/logo_bank_bjb_syariah.33444a09.png";